export const PORTAL_MODAL_VARIANTS = {
  MIDDLE: 'middle',
  BOTTOM: 'bottom',
}
